import React from "react";

export const About = (props) => {
  const data = props.data;

  return (
    <div id="about" className="about-section">
      <div className="container">
        <div className="about-layout">
          <div className="about-copy">
            <span className="about-eyebrow">
              {data ? data.eyebrow : "About Us"}
            </span>
            <h2 className="about-title">
              {data ? data.title : "Loading..."}
            </h2>

            <div className="about-body">
              <p className="about-lead">
                {data ? data.lead : "loading..."}
              </p>

              <blockquote className="about-mission">
                <span className="about-mission-label">Our Mission</span>
                <p>{data ? data.mission : "loading..."}</p>
              </blockquote>

              <p className="about-closing">
                {data ? data.closing : "loading..."}
              </p>
            </div>
          </div>

          <div className="about-visual" aria-hidden="true">
            <div className="about-visual-frame">
              <img
                src="img/about-us.jpg"
                className="img-responsive"
                alt=""
              />
            </div>
            <div className="about-visual-accent" />
          </div>
        </div>
      </div>
    </div>
  );
};
